import { styled } from "../../Theme";
import { StyleSheet } from "../../Theme";

interface StyledBurger {
  open: boolean;
}

export const BurgerStyleSheet: StyleSheet = {
  burgerSpan: {
    borderRadius: "0.1em",
    height: "0.5em",
    background: "grey",
    width: "100%",
  },
};

export const StyledBurger = styled.div<StyledBurger>`
  z-index: 999;
  width: 4em;
  height: 4em;
  position: fixed;
  background-color: transparent;
  border: none;
  margin-top: auto;
  top: 0.5em;
  right: 0.5em;
  display: none;
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    display: flex;
    justify-content: space-evenly;
    flex-flow: column;
    background-size: cover;
  }
  div {
    width: 3rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? "#ccc" : "#333")};
    border-radius: 10px;
    transition: all 0.2s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

export const Ul = styled.ul<StyledBurger>`
  z-index: 2;
  list-style: none;
  display: flex;
  flex: row;
  width: 100%;
  height: 100%;
  top: 0;
  margin: 0;
  padding: 0;
  position: absolute;

  @media (min-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    display: none;
  }

  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    position: absolute;
    flex-flow: column nowrap;
    background-image: -webkit-linear-gradient(110deg, #338afe 50%, #63a7ff 50%);
    background-image: -o-linear-gradient(110deg, #338afe 50%, #63a7ff 50%);
    background-image: -moz-linear-gradient(110deg, #338afe 50%, #63a7ff 50%);
    background-image: linear-gradient(110deg, #338afe 50%, #63a7ff 50%);
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: 0;
    height: 100vh;
    transition: transform 0.2s ease-in-out;
    li {
      color: #fff;
    }
  }
`;
